import { useEffect } from 'react'
import { useState } from 'react'
import { PDFImages } from './ModalSendPDF'
import { ImageType } from '../../interfaces/intakes.reports'

interface Props{
    img: ImageType
    images: PDFImages[]
    handleSelectImage: (images: PDFImages[], pid?: string) => void
    pid: string
}

export const ImagesPDF = ({ img, images, handleSelectImage, pid }:Props) => {

    const [checkRef, setCheckRef] = useState<boolean>(true)

    useEffect(() => {
        const pallet = images.find(pall => pall.pid === pid)
        setCheckRef(pallet?.images.some(i => i.imgURL === img.imgURL) || false)
        return () => { setCheckRef(true) }
    }, [images, img, pid])


    const addImage = (url:ImageType) => {

        setCheckRef(!checkRef) 

        const elPallet = images.find(pall => pall.pid === pid) 
        const elResto = images.filter(pall => pall.pid !== pid) || []

        if (!checkRef) {
            elPallet!.images.push(url)
            handleSelectImage([...elResto, elPallet!], pid)
        } else {
            const newP = elPallet!.images.filter(im => im.imgURL !== url.imgURL)
            elPallet!.images = newP
            handleSelectImage([...elResto, elPallet!], pid)
        }
    };

    return (

        <label className="modalPDF">
            <input
                type="checkbox"
                checked={checkRef}
                onChange={() => addImage(img)}
            />
            <div className="modalPDF__container">
                <img
                    className={`${checkRef ? null : "img-trans"}`}
                    src={img.imgURL_low}
                    alt={img.key_low}
                />
                <span className={`box-checked ${checkRef ? "check-on" : "check-off"}`}>
                    {
                        checkRef &&
                        <img
                            src='/assets/img/check.svg'
                            alt='check-icon'
                        />}
                </span>

                {
                    img.label &&
                    <div className='photo-tag-pdf'>
                        <p>{img.label}</p>
                    </div>
                }
            </div>
        </label>

    )
}
